<template>
    <div class="service">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' : 'content'">
            <div class="box">
                <div class="box-top">
                    <img src="../../assets/img/chat.png" />
                    <div class="right">
                        <p>{{ $t('支持服务') }}</p>
                        <p class="problem">{{ $t('如果您有任何问题，请联系我们') }}</p>
                    </div>
                </div>
                <div class="box-card">
                    <div class="item" v-for="(item,index) in list" :key="index" @click="toService(item)">
                        <div class="item-left">
                            <img v-if="item.qr_code" :src="item.qr_code" />
                            <div class="title-box">
                                <span>{{ item.username }}</span>
                                <span class="time"><i class="el-icon-time"></i>{{ $t('工作日') }}{{ item.btime }} A.M. - {{ item.etime }} P.M.</span>
                            </div>
                        </div>
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
import { service } from '../../api/index'
    import { mapGetters } from "vuex";
    export default {
        data() {
            return {
                list: []
            }
        },
        computed: {
            ...mapGetters("device", ["isMobile"]),
        },
        created() {
            this.getService()
        },
        methods: {
            getService() {
                service().then(res=> {
                    if (res.code == 0) {
                        this.list = res.data
                    }
                })
            },
            toService(item) {
                if (this.isMobile) {
                    window.location.href = item.url
                } else {
                    window.open(item.url)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.service {

    .content {
        background: #f8f8f8;
        background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
        background-position: 0;
        background-size: cover;
        display: flex;
        justify-content: center;
        min-height: 100vh;
        width: 100%;

        .box {
            width: 38%;
            margin: 40px auto;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            border-radius: 9px;

            .box-top {
                width: 70%;
                display: flex;
                align-items: center;
                padding: 20px;
                margin-left: 60px;

                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 20px;
                }

                p {
                    margin: 10px 0;
                    font-size: 18px;
                }

                .problem {
                    font-size: 14px;
                    color: #333;
                }
            }

            .box-card {
                padding: 20px;

                .item {
                    border-radius: 15px;
                    box-shadow: 0 8px 24px hsla(210, 8%, 62%, .2);
                    box-sizing: border-box;
                    display: flex;
                    font-size: 16px;
                    height: 80px;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    padding: 3% 6%;
                    width: 100%;
                    background-color: #fff;

                    img {
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                    }

                    .item-left {
                        display: flex;
                        align-items: center;

                        .title-box {
                            display: flex;
                            flex-direction: column;
                            margin-left: 20px;

                            span {
                                padding-top: 8px;
                                font-size: 18px;
                                
                            }

                            .time {
                                font-size: 14px;
                                color: #666;
                            }
                        }
                    }
                }

            }
        }
    }

    .m-content {

        .box {
            background-color: #fff;
            display: flex;
            flex-direction: column;
            border-radius: 9px;

            .box-top {
                display: flex;
                align-items: center;
                padding: 20px;

                img {
                    width: 80px;
                    height: 80px;
                    margin-right: 20px;
                }

                p {
                    margin: 5px 0;
                    font-size: 18px;
                }

                .problem {
                    font-size: 14px;
                    /* color: #333; */
                }
            }

            .box-card {
                padding: 20px;

                .item {
                    border-radius: 15px;
                    box-shadow: 0 8px 24px hsla(210, 8%, 62%, .2);
                    box-sizing: border-box;
                    display: flex;
                    font-size: 16px;
                    height: 80px;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    padding: 3% 6%;
                    width: 100%;
                    background-color: #fff;

                    img {
                        width: 50px;
                        height: 50px;
                        border-radius: 50%;
                    }

                    .item-left {
                        display: flex;
                        align-items: center;

                        .title-box {
                            display: flex;
                            flex-direction: column;
                            margin-left: 20px;

                            span {
                                padding-top: 4px;
                                font-size: 18px;
                                
                            }

                            .time {
                                font-size: 14px;
                                color: #666;
                            }
                        }
                    }
                }

            }
        }
    }
}
</style>